import * as React from "react";
const HumanResourcesIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 40",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 28.97a10.938 10.938 0 0 1 4.13-8.46 7.565 7.565 0 0 0-4.5-1.51A7.69 7.69 0 0 0 5 26.58V30h8zm22 0V30h8v-3.42A7.69 7.69 0 0 0 35.37 19a7.565 7.565 0 0 0-4.5 1.51A10.938 10.938 0 0 1 35 28.97zM15 30v3h18v-4.03a9 9 0 0 0-18 0z",
  style: {
    fill: "#000"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 13,
  r: 5,
  style: {
    fill: "#000"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 4,
  style: {
    fill: "#000"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 13,
  r: 4,
  style: {
    fill: "#000"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.56.44A1.495 1.495 0 0 0 46.5 0h-45A1.5 1.5 0 0 0 0 1.5V34a1.506 1.506 0 0 0 .025.25A1.506 1.506 0 0 0 0 34.5v4A1.5 1.5 0 0 0 1.5 40h45a1.5 1.5 0 0 0 1.5-1.5v-37a1.496 1.496 0 0 0-.44-1.06zM2.976 34.25A1.506 1.506 0 0 0 3 34V3h42v34H3v-2.5a1.506 1.506 0 0 0-.025-.25z",
  style: {
    fill: "#000"
  }
})));
export default HumanResourcesIcon;